import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Disclaimer = () => {
  const { t } = useTranslation();
  const sections = t('disclaimer.sections', [], { returnObjects: true });

  return (
    <>
      <Helmet>
        <title>{t('disclaimer.meta.title')}</title>
        <meta name="description" content={t('disclaimer.meta.description')} />
      </Helmet>

      {/* Hero Section */}
      <section className="bg-primary text-white py-20">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h1 className="text-4xl font-bold mb-6">{t('disclaimer.hero.title')}</h1>
            <p className="text-xl text-gray-200">
              {t('disclaimer.hero.subtitle')}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Disclaimer Content */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="prose prose-lg">
              <p className="text-gray-600 mb-8">
                {t('disclaimer.lastUpdate')}
              </p>
              <p className="text-gray-600 mb-12">
                {t('disclaimer.intro')}
              </p>
              {sections.map((section, index) => (
                <motion.div
                  key={section.title}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="mb-12"
                >
                  <h2 className="text-2xl font-bold mb-4">{section.title}</h2>
                  <div className="space-y-2">
                    {section.content.map((item, itemIndex) => (
                      <p key={itemIndex} className="text-gray-600">
                        {item}
                      </p>
                    ))}
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Disclaimer; 